import React, { useEffect, useState } from 'react';
import '../../scss/reset_password.scss';
import eyeicon from '../../images/login/eyeicon.png';
import { useNavigate, useLocation } from 'react-router-dom';
import Snackbars from '../Reusables/Snackbar';
import clairvoyix from '../../images/project/clairvoyix-image.gif';
import getCommonResponse from '../actions/Common';
import tickmark from'../../images/common/tick_mark.png';

function ResetPassword(props) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [code, setCode] = useState('');
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(null)
    const [enable, setEnable] = useState(true);
    const [passwordReset, setPasswordReset] = useState(false);

    function ToggleNew () {
        if(document.getElementsByClassName('password-new')[0].type === 'password') {
            document.getElementsByClassName('password-new')[0].type = 'text';
        }
        else {
            document.getElementsByClassName('password-new')[0].type = 'password'
        }
    }

    function ToggleConfirm () {
        if(document.getElementsByClassName('password-confirm')[0].type === 'password') {
            document.getElementsByClassName('password-confirm')[0].type = 'text';
        }
        else {
            document.getElementsByClassName('password-confirm')[0].type = 'password'
        }
    }

    useEffect(() => {
        const path = new URLSearchParams(location.search);
        const code = path.has('code') ? path.get('code') : '';
        const id = path.has('id') ? path.get('id') : '';

        setUserId(id);
        setCode(code);
    }, [])

    const ResetPassword = () => {
        if (newPassword == "") {
            setOpen(true);
            setError("New Password is mandatory")
        } else if (confirmPassword == "") {
            setOpen(true);
            setError("Confirm Password is mandatory")
        } else if(newPassword != "" && confirmPassword != "") {
            if(newPassword != confirmPassword) {
                setOpen(true);
                setError("Password mismatch")
            } else {
                setEnable(false)

                var details = {
                    Code: code,
                    UserId: userId,
                    NewPassword: newPassword,
                    ConfirmPassword: confirmPassword
                }
        
                const URL = `/api/users/reset-password`;
                getCommonResponse.PostDetailsWithApiKey(URL, details, (response) => {  
                    setEnable(true)
                    if(response.status == 200) {
                        setPasswordReset(true);
                    } else {
                        setOpen(true);
                        setError(response.data.message)
                    }
                });
            }
        }
    }

    const backToLogin = () => {
        navigate('/');
    }


    return (
        <div className='reset-password-container'>
            <div className='header'>
                <div className='header-left'>
                    <img src={clairvoyix}></img>
                </div>
            </div>
            <div className='reset-password-sub-container'>
                <div className='reset-password-section'>
                    {!passwordReset ? 
                    <div className='password-section'>
                        <h3>Reset Password</h3>
                        <div className='password-container'>
                            <input type='password' className='password password-new' placeholder='New Password' onChange={(e) => setNewPassword(e.target.value)}
                            maxLength={20}></input>
                            <img src={eyeicon} alt="eye-icon" onClick={ToggleNew}></img>
                        </div>
                        <div className='password-container'>
                            <input type='password' className='password password-confirm' placeholder='Confirm Password' onChange={(e) => setConfirmPassword(e.target.value)}
                            maxLength={20}></input>
                            <img src={eyeicon} alt="eye-icon" onClick={ToggleConfirm}></img>
                        </div>
                        <button disabled={!enable} className={`reset-button ${enable ? 'button-enable' : 'button-disable'}`} onClick={ResetPassword}>Reset Password</button> 
                    </div> : 
                    <div className='success-container'>
                        <img src={tickmark} />
                        <div className='success-message'>
                            Your password has been changed successfully!
                        </div>
                    </div>
                    }
                     <div>
                        <div onClick={backToLogin} className='back-to-login'><span>&#8592; </span>Back to log in</div>
                    </div>
                </div> 

                <Snackbars error={error} open={open} setOpen={setOpen}/>
            </div>
        </div>
    );
}

export default ResetPassword;